import { render, staticRenderFns } from "./student-class-attendance.vue?vue&type=template&id=594a82c6&"
import script from "./student-class-attendance.vue?vue&type=script&lang=js&"
export * from "./student-class-attendance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports